export default {
  name: 'marking--pdInformationP',
  apiService: 'shoes',
  apiPath: '/admin/pd_information_p',
};
